const etcStep = { etc: true, stepName: undefined, key: 'etc', etcDone: false };
function generateUiItemList({ stepList, currentStepIndex, }) {
    const lastItem = stepList[stepList.length - 1];
    const activeItem = stepList.find((item) => item.key === currentStepIndex);
    const foundIndex = stepList.findIndex((item) => item.key === currentStepIndex);
    const firstItems = foundIndex === 5 ? stepList.slice(0, 5) : stepList.slice(0, 4);
    if (stepList.length <= 8) {
        return stepList;
    }
    if (foundIndex <= 3) {
        return [...firstItems, etcStep, Object.assign({}, lastItem)];
    }
    if (foundIndex <= 5) {
        return [...firstItems, Object.assign({}, activeItem), etcStep, Object.assign({}, lastItem)];
    }
    if (currentStepIndex === lastItem.key) {
        return [...firstItems, Object.assign(Object.assign({}, etcStep), { etcDone: true }), Object.assign({}, lastItem)];
    }
    if (foundIndex > 4 && foundIndex + 3 < stepList.length) {
        return [
            ...firstItems,
            Object.assign(Object.assign({}, etcStep), { etcDone: true }),
            Object.assign({}, activeItem),
            Object.assign(Object.assign({}, etcStep), { key: 'etc2' }),
            Object.assign({}, lastItem),
        ];
    }
    if (foundIndex > 4 && foundIndex + 3 === stepList.length) {
        return [
            ...firstItems,
            Object.assign(Object.assign({}, etcStep), { etcDone: true }),
            Object.assign({}, activeItem),
            Object.assign({}, stepList[stepList.length - 2]),
            Object.assign({}, lastItem),
        ];
    }
    if (foundIndex >= 5) {
        return [
            ...firstItems,
            Object.assign(Object.assign({}, etcStep), { etcDone: true }),
            Object.assign({}, activeItem),
            Object.assign({}, lastItem),
        ];
    }
}
const useCountSteps = ({ stepList, currentStepIndex }) => {
    const uiItemList = generateUiItemList({ stepList, currentStepIndex }) || [];
    return { uiItemList };
};

export { useCountSteps };
